import humps from "humps"
import { Role } from "../models/enum";


export function GetUserRole(): Role|null {
    const userPermission = sessionStorage.getItem("userPermission");

    if (userPermission == null) return null;

    const userPermissionJson = JSON.parse(userPermission);

    const role = userPermissionJson.currentRole;

    switch (humps.camelize(role)) {
        case "superAdmin":
            return Role.SUPER_ADMIN;
        case "tenantAdmin":
            return Role.TENANT_ADMIN;
        case "orgAdmin":
            return Role.ORG_ADMIN;
        case "claimManager":
        case "rehabManager":
            return Role.MANAGER;
        case "coach":
            return Role.COACH;
        case "associates":
            return Role.ASSOCIATES;
        case "claimant":
            return Role.END_USER;
        default:
            return null;
    }
}